import './App.css'
import React, { Component } from 'react'
import {
  Redirect,
  Route,
  BrowserRouter as Router,
  Switch,
} from 'react-router-dom'
import FarmInfo from './views/FarmInfo'
import InteractiveMap from './views/InteractiveMap'
import Landing from './views/Landing'
import apiRoot from './common/util/api_root'
import queryString from 'query-string'

const farmsRequest = new Request(`${apiRoot}/map`)

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      farms: [],
      fetchStatus: '',
      activeInfoWindowId: null,
      selectedFarm: null,
    }
  }

  componentWillMount() {
    this.updateFetchStatus('Fetching Farms')
    fetch(farmsRequest)
      .then(response => response.json())
      .then(farms => this.updateFarmsList(farms))
      .catch(error => this.updateFetchStatus(error))
  }

  getFarmInfo = (id) => {
    this.updateFetchStatus(`Fetching Farm(${id}) Info`)
    const farmInfoRequest = new Request(`${apiRoot}/farm/?farmID=${id}`)
    fetch(farmInfoRequest)
      .then(response => response.json())
      .then(farm => this.setState({ selectedFarm: farm }))
      .catch(error => this.updateFetchStatus(error))
  }

  updateActiveInfoWindowId = (windowId) =>
    this.setState(prevState => ({ activeInfoWindowId: windowId }))

  updateFarmsList = (farmArray) =>
    this.setState(prevState => ({ farms: farmArray }))

  updateFetchStatus = (newStatus) =>
    this.setState(prevState => ({ fetchStatus: newStatus }))

  updateSelectedFarm = (farm) =>
    this.setState(prevState => ({ selectedFarm: farm }))

  updateUrlParams = (history, newUrl) => {
    history.push(`${newUrl}`)
  }

  Landing = (context) => (
    <Landing
      distance={Number(queryString.parse(context.history.location.search).distance)}
      history={context.history}
      mapCenter={
        {
          lat: Number(queryString.parse(context.history.location.search).lat),
          lng: Number(queryString.parse(context.history.location.search).lng),
        }
      }
      updateUrlParams={this.updateUrlParams}
      zip={Number(queryString.parse(context.history.location.search).zip)}
    />
  )

  InteractiveMap = (context) => (
    <InteractiveMap
      distance={Number(queryString.parse(context.history.location.search).distance)}
      farms={this.state.farms}
      getActiveInfoWindowId={this.state.activeInfoWindowId}
      getFarmInfo={this.getFarmInfo}
      history={context.history}
      mapCenter={
        {
          lat: Number(queryString.parse(context.history.location.search).lat),
          lng: Number(queryString.parse(context.history.location.search).lng),
        }
      }
      selectedFarm={this.state.selectedFarm}
      updateActiveInfoWindowId={this.updateActiveInfoWindowId}
      updateUrlParams={this.updateUrlParams}
      zip={Number(queryString.parse(context.history.location.search).zip)}
    />
  )

  FarmInfo = (context) => (
    <FarmInfo
      filteredFarms={this.state.farms}
      getFarmInfo={this.getFarmInfo}
      history={context.history}
      selectedFarm={this.state.selectedFarm}
    />
  )

  render() {
    const { activeInfoWindowId, farms, fetchStatus, selectedFarm } = this.state
    // console.log({ activeInfoWindowId, farms, fetchStatus, selectedFarm })
    return (
      <Router>
        <Switch>
          <Route
            path='/landing'
            render={this.Landing}
          />
          <Route
            path='/interactive_map'
            render={this.InteractiveMap}
          />
          <Route
            path='/farm_info'
            render={this.FarmInfo}
          />
          <Redirect from='/' to='/landing' />
        </Switch>
      </Router>
    )
  }
}

export default (App)



// WEBPACK FOOTER //
// ./src/App.js